import { ArrowUpRight, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const currency = new Intl.NumberFormat("nb-NO", { style: "currency", currency: "NOK", maximumFractionDigits: 0 });

export default function VehicleDialog({ copy, vehicle, onClose }) {
  return (
    <AnimatePresence>
      {vehicle && (
        <motion.div className="vehicle-dialog-backdrop" data-testid="vehicle-dialog" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
          <motion.div className="vehicle-dialog" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }} onClick={(event) => event.stopPropagation()}>
            <button aria-label="Lukk bilvisning" className="dialog-close" data-testid="vehicle-dialog-close-button" onClick={onClose}><X size={20} /></button>
            <img src={vehicle.main_image} alt={`${vehicle.brand} ${vehicle.model}`} data-testid="vehicle-dialog-image" />
            <div className="vehicle-dialog-content">
              <p className="section-eyebrow" data-testid="vehicle-dialog-brand">{vehicle.brand}</p>
              <h2 data-testid="vehicle-dialog-title">{vehicle.model} {vehicle.variant}</h2>
              <p data-testid="vehicle-dialog-description">{vehicle.description}</p>
              <div className="dialog-meta" data-testid="vehicle-dialog-meta"><span>{vehicle.year}</span><span>{new Intl.NumberFormat("nb-NO").format(vehicle.km)} km</span><span>{vehicle.fuel}</span><span>{vehicle.transmission}</span></div>
              <div className="dialog-footer"><strong data-testid="vehicle-dialog-price">{currency.format(vehicle.price)}</strong>{vehicle.finn_link && <a href={vehicle.finn_link} target="_blank" rel="noreferrer" data-testid="vehicle-dialog-finn-link">{copy.vehicle_finn_label} <ArrowUpRight size={15} /></a>}</div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}